import { Resume } from "@/types/resume/v1"
import { IPageMarginAttributes, IPageSizeAttributes, PageOrientation } from "docx"
import { IPageConfig } from "../types"

export const DEFAULT_PAGE_SIZE: IPageSizeAttributes = {
  width: '8.5in',
  height: '11in',
  orientation: PageOrientation.PORTRAIT,
}

export const NarrowPageMargin: IPageMarginAttributes = {
  top: "0.5in",
  right: "0.5in",
  bottom: "0.5in",
  left: "0.5in",
}

export const DefaultPageMargin: IPageMarginAttributes = {
  top: "0.75in",
  right: "0.75in",
  bottom: "0.75in",
  left: "0.75in",
}

export const WidePageMargin: IPageMarginAttributes = {
  top: "1in",
  right: "1in",
  bottom: "1in",
  left: "1in",
}

export const PageMarginMap = {
  narrow: NarrowPageMargin,
  default: DefaultPageMargin,
  wide: WidePageMargin,
}

export function getResumePageConfig(meta?: Resume.Meta): IPageConfig {
  const marginSize = meta?.marginSize || 'default'

  const margin = PageMarginMap[marginSize] || DefaultPageMargin

  return {
    size: DEFAULT_PAGE_SIZE,
    margin,
  }
}
